export const ROOT_PATHNAME = '/';
export const SIGNUP_PATHNAME = '/signup';
export const LOGIN_PATHNAME = '/login';
export const PROFILE_PATHNAME = '/profile';
